/**
 * Today's date in the browser's timezone as M/D/YY (e.g. "1/15/26"). The orders Late tab
 * sends it as the exclusive `requested_ship_date=<date>:lt` boundary, so an order due today
 * is not late. Do not switch to a "tomorrow" boundary (DESIGN.md, 'Order "late" status'
 * under "Cards, Panels, And Dashboards").
 */
export function getTodayDate(date = new Date()) {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);

  return `${month}/${day}/${year}`;
}
